angular.module('uofa.agentsportal')

/**
 * Applications controller for display of applications.
 *
 * @author Michael Wolfindale <m.wolfindale@abdn.ac.uk>
 */
.controller('ApplicationsCtrl', function ApplicationsCtrl($scope, $http) {

  $http.get(window.angular_datasources.config.app.url + '/api/v1/applicants/' + $scope.angular_datasources.data.applicantId + '/' + $scope.angular_datasources.data.applicationId).success(function(application) {
    $scope.application = application;
  });

});
